import { gql, useFragment } from "@apollo/client";

// Style
import style from "./text-and-image.module.scss";

// Constants
import { textImageBlock } from "@/constants/constants";
import { imgFields } from "@/constants/gql-fields";

// Components
import Image from "next/image";
import ModuleSettings from "@/components-modules/module-settings/module-settings";
import Container from "@/components-layout/container/container";

export default function TextAndImage({ module }) {
  const { complete, data } = useFragment({
    fragment: TextAndImage.fragments.module,
    fragmentName: "TextImageFragment",
    from: {
      __typename: module.__typename,
      id: module.id,
    },
  });

  if (!complete) {
    return;
  }

  // -- If Hide Module -- //
  if (data.textAndImageBlockModuleSettings.hideModule) {
    return;
  }

  // Variables
  const moduleSettings = data.textAndImageBlockModuleSettings;
  const imageType = data.imageOrSvg;
  const containerAtts = {
    "data-direction": data.direction,
    "data-mobile-direction": data.mobileDirection,
    "data-v-align": data.vAlign,
    "data-width": data.contentWidth,
  };

  return (
    <section id={moduleSettings.module_id} className={moduleSettings.classes}>
      <ModuleSettings settings={moduleSettings} />

      <Container atts={containerAtts} className={style.container}>
        <div className={style.moduleTextContainer} data-align={data.hAlign}>
          <div
            className={style.moduleText}
            style={{ color: `${data.textColor}` }}
            dangerouslySetInnerHTML={{ __html: data.text }}
          />
        </div>

        {imageType === "image" && (
          <figure className={style.moduleImageContainer}>
            <div className={style.moduleImageObject}>
              <Image
                src={data.image.node["sourceUrl"]}
                width={1400}
                height={1400}
                alt={data.image["altText"] ?? ""}
              />
            </div>
          </figure>
        )}

        {imageType === "svg" && (
          <figure className={style.moduleImageContainer}>
            <div
              className={style.moduleSvgObject}
              dangerouslySetInnerHTML={{ __html: data.svgCode }}
            />
          </figure>
        )}
      </Container>
    </section>
  );
}

TextAndImage.fragments = {
  module: gql`
    fragment TextImageFragment on ${textImageBlock} {
      id
      __typename
      contentWidth
      direction
      hAlign
      mobileDirection
      text
      imageOrSvg
      image {
        ${imgFields}
      }
      svgBgColor
      svgCode
      svgColor
      textColor
      vAlign
      
      # -- Module General Settings
      textAndImageBlockModuleSettings {
        ...ModSetFragment @unmask(mode: "migrate")
      } 
    }
    ${ModuleSettings.fragments.entry}
  `,
};
